/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-04-28T09:57:01.096
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getBlockEditInit,
	getBlockView
} from '@api/storagemanage/Block';

import {
listUnitInit,
listUnitByAuthorizations,
deleteUnit
} from '@api/storagemanage/Unit';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getBlockEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getBlockEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getBlockView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getBlockView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
